import {
  CADASTRAUSUSARIOEMPRESA,
  CADASTROEMPRESAS,
  DASHBOARD,
  DEFAULT,
  EDITAREMPRESAS,
  EMPRESAS,
  HOME,
  LOGIN,
  USUARIOSEMPRESA,
  REGISTERFAVORITES,
  ADDFAVORITES,
  ADDSOLICITACAOPAGAMENTO,
  SOLICITACAOPAGAMENTO,
  VENDASBOLETOS,
  SOLICITACAOTRANSFERENCIA,
  ADDSOLICITACAOTRANSFERENCIA,
  TRANSFERENCIAS,
  PAGAMENTOSNOVO,
  ADDSOLICITACAOTRANSFERENCIANEW,
  TRANSFERENCIASNOVO,
  VENDADIGITADA,
  ADDVENDADIGITADA,
  LANCAMENTOSFUTUROS,
  DADOSPESSOAIS,
  TARIFAS,
  TAXASPESSOAIS,
  CONTASFIXAS,
  CADASTROCONTASFIXAS,
  SUPORT,
  ADDSUPORT,
  NOVAVENDASBOLETOS,
  VENDASBOLETO,
  ADDVENDADIGITADACARTAO,
  FINANCEIROSUPERVISOR,
  NOVAVENDASBOLEPIX,
  VENDASBOLEPIX,
  NOVAVENDABOLEPIXLOTE,
  FINANCEIRO,
  PIXDIRECT,
  ADDPIXDIRECT,
  ADDSOLICITACAOPAGAMENTONEW,
} from "../constants/paths";

export const goToHome = (navigate: any) => {
  navigate(HOME);
};

export const goToLogin = (navigate: any) => {
  navigate(LOGIN);
};

export const goToDefault = (navigate: any) => {
  navigate(DEFAULT);
};

export const goToDashboard = (navigate: any) => {
  navigate(DASHBOARD);
};

export const goToAddCompany = (navigate: any) => {
  navigate(CADASTROEMPRESAS);
};

export const goToCompanyList = (navigate: any) => {
  navigate(EMPRESAS);
};

export const goToEditCompany = (navigate: any) => {
  navigate(EDITAREMPRESAS);
};

export const goToUsersCompany = (navigate: any) => {
  navigate(USUARIOSEMPRESA);
};

export const goToAddUserCompany = (navigate: any) => {
  navigate(CADASTRAUSUSARIOEMPRESA);
};
export const goToAddTransferSolicitationListNew = (navigate: any) => {
  navigate(ADDSOLICITACAOTRANSFERENCIANEW);
};
export const goToAddPaymentNew = (navigate: any) => {
  navigate(ADDSOLICITACAOPAGAMENTONEW);
};
export const goToAddFavorites = (navigate: any) => {
  navigate(ADDFAVORITES);
};

export const goToListFavorites = (navigate: any) => {
  navigate(REGISTERFAVORITES);
};

export const goToPage = (navigate: any, path: string) => {
  navigate(path);
};

export const goToAddPayment = (navigate: any) => {
  navigate(ADDSOLICITACAOPAGAMENTO);
};
export const goToPaymentSolicitationListNew = (navigate: any) => {
  navigate(PAGAMENTOSNOVO);
};
export const goToTransferSolicitationListNew = (navigate: any) => {
  navigate(TRANSFERENCIASNOVO);
};
export const goToPaymentSolicitationList = (navigate: any) => {
  navigate(VENDASBOLETOS);
};

export const goToTransferSolicitationList = (navigate: any) => {
  navigate(TRANSFERENCIAS);
};
export const goToAddTransferSolicitationList = (navigate: any) => {
  navigate(ADDSOLICITACAOTRANSFERENCIA);
};
export const goToVendaBolePixListagem = (navigate: any) => {
  navigate(VENDASBOLEPIX);
};
export const goToAddVendaBolePix = (navigate: any) => {
  navigate(NOVAVENDASBOLEPIX);
};
export const goToAddVendaBolePixLote = (navigate: any) => {
  navigate(NOVAVENDABOLEPIXLOTE);
};
export const goToVendaDigitadaList = (navigate: any) => {
  navigate(VENDADIGITADA);
};

export const goToAddVendaDigitada = (navigate: any) => {
  navigate(ADDVENDADIGITADA);
};

export const goToAddVendaDigitadaCartao = (navigate: any) => {
  navigate(ADDVENDADIGITADACARTAO);
};

export const goToLancamentosFuturos = (navigate: any) => {
  navigate(LANCAMENTOSFUTUROS);
};

export const goToEditFavorecidos = (navigate: any, id: any) => {
  navigate(`/financeiro/editar/favorito/${id}`);
};

export const goToSimplifiedDetailsSupervisorClient = (
  navigate: any,
  id: any
) => {
  navigate(`/financeiro/cliente/${id}`);
};

export const goToPersonalData = (navigate: any) => {
  navigate(DADOSPESSOAIS);
};

export const goToTarifasCliente = (navigate: any) => {
  navigate(TAXASPESSOAIS);
};

export const goToContaFixaList = (navigate: any) => {
  navigate(CONTASFIXAS);
};

export const goToAddContasFixas = (navigate: any) => {
  navigate(CADASTROCONTASFIXAS);
};

export const goToSuport = (navigate: any) => {
  navigate(SUPORT);
};

export const goToAddSuport = (navigate: any) => {
  navigate(ADDSUPORT);
};

export const goToAddVendaBoleto = (navigate: any) => {
  navigate(NOVAVENDASBOLETOS);
};

export const goToVendaBoletoListagem = (navigate: any) => {
  navigate(VENDASBOLETO);
};

export const goToConsultaTransacaoCliente = (navigate: any, id: any) => {
  navigate(`/financeiro/consultatransacao/${id}`);
};

export const goToExtractClientsSupervisor = (navigate: any) => {
  navigate(FINANCEIRO);
};

// pix direto
export const goToPixDireto = (navigate: any) => {
  navigate(PIXDIRECT);
};

export const goToAddPixDireto = (navigate: any) => {
  navigate(ADDPIXDIRECT);
};
